import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { BookingLocationCodes } from '@fcom/common/interfaces/booking';
import { TripType } from '@fcom/core/interfaces';

@Component({
  selector: 'fin-trip-location-info',
  templateUrl: './trip-location-info.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TripLocationInfoComponent {
  readonly SvgLibraryIcon = SvgLibraryIcon;
  readonly TripType = TripType;

  @Input() tripType: TripType;
  @Input() locations: BookingLocationCodes[];
}
